import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";
const companyId = process.env.REACT_APP_COMPANY_ID;

export const getOrdersToDeposit = createAsyncThunk(
  "transactions/getOrdersToDeposit",
  async (args, thunkAPI) => {
    const { pageSize, pageNumber, searchQuery, eventId, status } = args;

    const response = await axiosInstance.request({
      url: `/events/${eventId}/orders?fields=id,intId,orderNumber,amount,status,fullName,email`,
      method: "get",
      params: { pageSize, pageNumber, searchQuery },
    });
    return { data: response };
  }
);

export const getToDeposits = createAsyncThunk(
  "transactions/getToDeposits",
  async (args, thunkAPI) => {
    const { searchQuery, eventId } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/deposits`,
      method: "get",
      params: { searchQuery },
    });
    return { data: response };
  }
);

export const getDeposit = createAsyncThunk(
  "transactions/getDeposit",
  async (args, thunkAPI) => {
    const { searchQuery, eventId, depositId } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/deposits/${depositId}`,
      method: "get",
      params: { searchQuery },
    });
    return { data: response };
  }
);

export const validateOrders = createAsyncThunk(
  "transactions/validateOrders",
  async (args, thunkAPI) => {
    const { eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/deposits/validate`,
      method: "post",
      data: data,
    });
    return { data: response.data };
  }
);

export const setDeposit = createAsyncThunk(
  "transactions/setDeposit",
  async (args, thunkAPI) => {
    const { eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/deposits`,
      method: "post",
      data: data,
    });
    return { data: response.data };
  }
);

export const transactionsSlice = createSlice({
  name: "transactions",
  initialState: {
    amount: 0,
    orders: [],
    deposit: {},
    totalRows: 0,
    deposits: [],
    inputSearch: "",
    eventsArray: [],
    ordersLoader: false,
    validateOrdersLoader: false,
    eventSelected: {
      value: "123456-QWERTY-123654-POIUYT-456789",
      label: "Selecciona un evento",
    },
    depositsEg: [
      {
        intId: 1,
        date: 1678212991,
        reference: "01479",
        status: "done",
        orders: [
          {
            intId: 1,
            orderNumber: "Gabo",
            amount: 85420,
          },
          {
            intId: 2,
            orderNumber: "Mayra",
            amount: 85421,
          },
          {
            intId: 3,
            orderNumber: "Jorge",
            amount: 85422,
          },
          {
            intId: 4,
            orderNumber: "Aldo",
            amount: 85423,
          },
          {
            intId: 5,
            orderNumber: "Chris",
            amount: 85424,
          },
        ],
      },
      {
        intId: 2,
        date: 1678212991,
        reference: "0147-qw",
        status: "pending",
        orders: [
          {
            intId: 1,
            orderNumber: "uno",
            amount: 85420,
          },
          {
            intId: 2,
            orderNumber: "dos",
            amount: 85421,
          },
          {
            intId: 3,
            orderNumber: "tres",
            amount: 85422,
          },
          {
            intId: 4,
            orderNumber: "cuatro",
            amount: 85423,
          },
        ],
      },
      {
        intId: 3,
        date: 1678212991,
        reference: "4147-qwqwe",
        status: "done",
        orders: [
          {
            intId: 1,
            orderNumber: "miercoles",
            amount: 85420,
          },
          {
            intId: 2,
            orderNumber: "martes",
            amount: 85421,
          },
          {
            intId: 3,
            orderNumber: "lunes",
            amount: 85422,
          },
          {
            intId: 4,
            orderNumber: "sabado",
            amount: 85423,
          },
          {
            intId: 5,
            orderNumber: "domingo",
            amount: 85425,
          },
          {
            intId: 6,
            orderNumber: "viernes",
            amount: 854256,
          },
        ],
      },
      {
        intId: 4,
        date: 1678212991,
        reference: "4147-mbappe",
        status: "done",
        orders: [],
      },
    ],
  },
  reducers: {
    setEventList: (state, action) => {
      state.eventsArray = action.payload;
    },
    setInputSearch: (state, action) => {
      state.inputSearch = action.payload;
    },
    setEventSelected: (state, action) => {
      state.eventSelected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrdersToDeposit.fulfilled, (state, action) => {
        state.orders = action.payload.data.data;
        state.totalRows = JSON.parse(
          action?.payload?.data?.headers["x-pagination"]
        )?.totalCount;
        state.ordersLoader = false;
      })
      .addCase(getOrdersToDeposit.pending, (state, action) => {
        state.ordersLoader = true;
      })
      .addCase(validateOrders.fulfilled, (state, action) => {
        state.validateOrdersLoader = false;
        state.amount = action?.payload?.data?.amount;
      })
      .addCase(validateOrders.pending, (state, action) => {
        state.validateOrdersLoader = true;
      })
      .addCase(setDeposit.fulfilled, (state, action) => {
        state.validateOrdersLoader = false;
        state.amount = action?.payload?.data?.amount;
      })
      .addCase(setDeposit.pending, (state, action) => {
        state.validateOrdersLoader = true;
      })
      .addCase(getToDeposits.fulfilled, (state, action) => {
        state.validateOrdersLoader = false;
        state.deposits = action?.payload?.data.data;
      })
      .addCase(getToDeposits.pending, (state, action) => {
        state.validateOrdersLoader = true;
      })
      .addCase(getDeposit.fulfilled, (state, action) => {
        state.validateOrdersLoader = false;
        state.deposit = action?.payload?.data.data;
      })
      .addCase(getDeposit.pending, (state, action) => {
        state.validateOrdersLoader = true;
      })
      .addCase(getDeposit.rejected, (state, action) => {
        state.validateOrdersLoader = false;
      });
  },
});

export const { setInputSearch, setEventSelected } = transactionsSlice.actions;

export default transactionsSlice.reducer;
